import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { FORGET_PASSWORD, FORGET_PASSWORD_RESEND_CODE, FORGET_PASSWORD_SUCCESS } from "./actionTypes"
import { userForgetPasswordSuccess, userForgetPasswordError } from "./actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import { forgetPwd, forgetPwdResendCode } from "../../../helpers/backend_helper"

import toast from "react-hot-toast";

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* forgetUser({ payload: { user, history } }) {
  try {
    const response = yield call(forgetPwd, {
      email: user.email
    }) 
    if (response.status === "success") {
      yield put(userForgetPasswordSuccess(response))
      toast.success(response.message);
      history.push(`/reset-password/${user.email}`);
     
    } else {
      yield put(userForgetPasswordError(response))
      toast.error(response.message);
    }
  } catch (error) {
    // console.log(error)
    toast.error(error.response.data.message,{duration: 6000})
    yield put(userForgetPasswordError(error))  
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
}

//Forget password resend code
function* forgetUserResendCode({ payload: { user, history } }) {
  try {
    const response = yield call(forgetPwdResendCode, {
      email: user.email
    })
    if (response.status === "success") {
      toast.success(response.message);
    } else {
      toast.error(response.message);
    }
  } catch (error) {
    toast.error(error.response.data.message,{duration: 6000})
    // toast.error(error);
  }
}

export function* watchUserPasswordForgetResendCode() {
  yield takeEvery(FORGET_PASSWORD_RESEND_CODE, forgetUserResendCode)
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)])
}

export function* ForgetPasswordResendCodeSaga() {
  yield all([fork(watchUserPasswordForgetResendCode)])
}

export default forgetPasswordSaga
